import styled from 'styled-components'

export const SpaceDividerStyled = styled.hr`
  border-top: 1px solid ${(props) => props.theme.colors.content.border};
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
  margin: 0;
`
